/**
 * Field Registry - Maps field types to their corresponding field components
 * Following DDD principles for maintainability and scalability
 */

import TextFieldInput from './fields/TextFieldInput';
import SelectFieldInput from './fields/SelectFieldInput';
import CurrencyFieldInput from './fields/CurrencyFieldInput';
import PriceFieldInput from './fields/PriceFieldInput';
import DateFieldInput from './fields/DateFieldInput';
import PhoneFieldInput from './fields/PhoneFieldInput';
import RadioFieldInput from './fields/RadioFieldInput';
import CheckboxFieldInput from './fields/CheckboxFieldInput';
import SwitchFieldInput from './fields/SwitchFieldInput';
import FileFieldInput from './fields/FileFieldInput';
import SignatureFieldInput from './fields/SignatureFieldInput';
import SliderFieldInput from './fields/SliderFieldInput';
import RatingFieldInput from './fields/RatingFieldInput';
import RepeaterFieldInput from './fields/RepeaterFieldInput';
import HiddenFieldInput from './fields/HiddenFieldInput';
import TagsFieldInput from './fields/TagsFieldInput';

export const FIELD_TYPES = {
  TEXT: 'text',
  EMAIL: 'email',
  URL: 'url',
  PASSWORD: 'password', // placeholder
  NUMBER: 'number',
  TEXTAREA: 'textarea',
  TEL: 'tel',
  PHONE: 'phone',
  SELECT: 'select',
  CURRENCY: 'currency',
  PRICE: 'price',
  DATE: 'date',
  DATETIME: 'datetime',
  DATETIME_LOCAL: 'datetime-local',
  TIME: 'time',
  MONTH: 'month',
  WEEK: 'week',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  SWITCH: 'switch',
  FILE: 'file',
  ATTACHMENT: 'attachment',
  IMAGE: 'image',
  SIGNATURE: 'signature',
  RANGE: 'range',
  SLIDER: 'slider',
  RATING: 'rating',
  REPEATER: 'repeater',
  REPEATABLE: 'repeatable',
  TAGS: 'tags',
  HIDDEN: 'hidden',
  HEADING: 'heading',
  PARAGRAPH: 'paragraph',
  DIVIDER: 'divider',
};

export const FIELD_CATEGORIES = {
  TEXT: [
    FIELD_TYPES.TEXT,
    FIELD_TYPES.EMAIL,
    FIELD_TYPES.URL,
    FIELD_TYPES.PASSWORD,
    FIELD_TYPES.NUMBER,
    FIELD_TYPES.TEXTAREA,
  ],
  PHONE: [FIELD_TYPES.TEL, FIELD_TYPES.PHONE],
  SELECT: [FIELD_TYPES.SELECT],
  CURRENCY: [FIELD_TYPES.CURRENCY],
  PRICE: [FIELD_TYPES.PRICE],
  DATE: [
    FIELD_TYPES.DATE,
    FIELD_TYPES.DATETIME,
    FIELD_TYPES.DATETIME_LOCAL,
    FIELD_TYPES.TIME,
    FIELD_TYPES.MONTH,
    FIELD_TYPES.WEEK,
  ],
  RADIO: [FIELD_TYPES.RADIO],
  CHECKBOX: [FIELD_TYPES.CHECKBOX],
  SWITCH: [FIELD_TYPES.SWITCH],
  FILE: [FIELD_TYPES.FILE, FIELD_TYPES.ATTACHMENT, FIELD_TYPES.IMAGE],
  SIGNATURE: [FIELD_TYPES.SIGNATURE],
  SLIDER: [FIELD_TYPES.RANGE, FIELD_TYPES.SLIDER],
  RATING: [FIELD_TYPES.RATING],
  REPEATER: [FIELD_TYPES.REPEATER, FIELD_TYPES.REPEATABLE],
  TAGS: [FIELD_TYPES.TAGS],
  HIDDEN: [FIELD_TYPES.HIDDEN],
  DISPLAY_ONLY: [
    FIELD_TYPES.HEADING,
    FIELD_TYPES.PARAGRAPH,
    FIELD_TYPES.DIVIDER,
  ],
};

export const fieldRegistry = {
  [FIELD_TYPES.TEXT]: TextFieldInput,
  [FIELD_TYPES.EMAIL]: TextFieldInput,
  [FIELD_TYPES.URL]: TextFieldInput,
  [FIELD_TYPES.PASSWORD]: TextFieldInput,
  [FIELD_TYPES.NUMBER]: TextFieldInput,
  [FIELD_TYPES.TEXTAREA]: TextFieldInput,
  [FIELD_TYPES.TEL]: PhoneFieldInput,
  [FIELD_TYPES.PHONE]: PhoneFieldInput,
  [FIELD_TYPES.SELECT]: SelectFieldInput,
  [FIELD_TYPES.CURRENCY]: CurrencyFieldInput,
  [FIELD_TYPES.PRICE]: PriceFieldInput,
  [FIELD_TYPES.DATE]: DateFieldInput,
  [FIELD_TYPES.DATETIME]: DateFieldInput,
  [FIELD_TYPES.DATETIME_LOCAL]: DateFieldInput,
  [FIELD_TYPES.TIME]: DateFieldInput,
  [FIELD_TYPES.MONTH]: DateFieldInput,
  [FIELD_TYPES.WEEK]: DateFieldInput,
  [FIELD_TYPES.RADIO]: RadioFieldInput,
  [FIELD_TYPES.CHECKBOX]: CheckboxFieldInput,
  [FIELD_TYPES.SWITCH]: SwitchFieldInput,
  [FIELD_TYPES.FILE]: FileFieldInput,
  [FIELD_TYPES.ATTACHMENT]: FileFieldInput,
  [FIELD_TYPES.IMAGE]: FileFieldInput,
  [FIELD_TYPES.SIGNATURE]: SignatureFieldInput,
  [FIELD_TYPES.RANGE]: SliderFieldInput,
  [FIELD_TYPES.SLIDER]: SliderFieldInput,
  [FIELD_TYPES.RATING]: RatingFieldInput,
  [FIELD_TYPES.REPEATER]: RepeaterFieldInput,
  [FIELD_TYPES.REPEATABLE]: RepeaterFieldInput,
  [FIELD_TYPES.HIDDEN]: HiddenFieldInput,
  [FIELD_TYPES.TAGS]: TagsFieldInput,
};

export const getFieldComponent = (type) => {
  return fieldRegistry[type] || TextFieldInput;
};

export const isDisplayOnlyField = (type) => {
  return FIELD_CATEGORIES.DISPLAY_ONLY.includes(type);
};
